// This file was autogenerated from /frontend/sail-next/packages/docs/src/component-examples/FormFieldGroup/basic.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { TextField, FormFieldGroup } from '@sail/ui';
export function Basic() {
  return <FormFieldGroup legend="Full name" description="Enter your full name">
      <TextField label="First name" placeholder="First name" hiddenElements={['label']} />
      <TextField label="Last name" placeholder="Last name" hiddenElements={['label']} />
    </FormFieldGroup>;
}